
import ImageUploading from 'react-images-uploading';


const ImageUploader = ({
  value = [],
  onChange,
  maxNumber = 5,
  acceptType = ["jpg", "jpeg", "png"],
  errorMessage = null
}) => {
  return (
    <div>
      <ImageUploading
        multiple
        value={value}
        onChange={onChange}
        maxNumber={maxNumber}
        dataURLKey="data_url"
        acceptType={acceptType}
      >
        {({
          imageList,
          onImageUpload,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps
        }) => (
          <div className="upload__image-wrapper">
            <div
              className={`border-2 border-dashed rounded-md p-4 text-center cursor-pointer ${
                isDragging ? "border-blue-500 bg-blue-50" : "border-gray-300"
              }`}
              onClick={onImageUpload}
              {...dragProps}
            >
              <p className="text-gray-500">
                Drag and drop or click to upload
              </p>
            </div>
            
            <div className="flex flex-wrap gap-4 mt-4">
              {imageList.map((image, index) => (
                <div key={index} className="relative">
                  <img
                    src={image.data_url}
                    alt={`image-${index}`}
                    className="h-24 w-24 object-cover rounded-md"
                  />
                  <div className="absolute top-0 right-0 flex space-x-1">
                    <button
                      type="button"
                      className="bg-white/80 rounded-full p-1 text-gray-700 hover:bg-white"
                      onClick={() => onImageUpdate(index)}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                      </svg>
                    </button>
                    <button
                      type="button"
                      className="bg-white/80 rounded-full p-1 text-gray-700 hover:bg-white"
                      onClick={() => onImageRemove(index)}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 6L6 18M6 6l12 12"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </ImageUploading>
      {errorMessage && (
        <p className="text-red-500 text-sm mt-1">{errorMessage}</p>
      )}
    </div>
  );
};

export default ImageUploader;
